import React, { Component } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  SKILL_OPTIONS,
  SkillAsAbility,
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";

type Props = {
  obj: SkillAsAbility;
  onChange: (changed: SkillAsAbility) => void; 
  disabled: boolean;
}

export interface State { 
  obj: SkillAsAbility;
  reloading: boolean;
  show_effect: string;
  special_refresh_rule: boolean;
}

class SkillAsAbilityInput extends Component<Props, State> {
  public static defaultProps = {
    disabled: false
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      reloading: false,
      show_effect: "",
      special_refresh_rule: false,
      obj: props.obj.clone()
    };
  }

  componentDidMount() {
  }

  render() {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 6
          }}>
          <SelectStringBox
            name="Action Cost"
            options={[
              { id: "A", text: "Action", disabled: false, reason: "" },
              { id: "BA", text: "Bonus Action", disabled: false, reason: "" },
              { id: "RA", text: "Reaction", disabled: false, reason: "" }
            ]}
            value={this.state.obj.casting_time}
            onChange={(value: string) => {
              const obj = this.state.obj;
              (obj as any).casting_time = value;
              this.setState({ obj }, () => {
                this.props.onChange(obj);
              });
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 6
          }}>
          <SelectStringBox
            name="Skill"
            options={SKILL_OPTIONS}
            values={this.state.obj.skill_ids}
            multiple
            onChange={(changed: string[]) => {
              const obj = this.state.obj;
              obj.skill_ids = changed;
              this.setState({ obj }, () => {
                this.props.onChange(obj);
              });
            }}
          />
        </Grid>
      </Grid>
    );
  }
}

export default SkillAsAbilityInput;
